import request from "@/utils/request";

export function index(params) {
  return request({
    url: "/quiz/questions",
    method: "get",
    params: params
  });
}

export function inventory(params) {
  return request({
    url: "/quiz/question/inventory",
    method: "get",
    params
  });
}

export function show(id) {
  return request({
    url: `/quiz/questions/${id}`,
    method: "get"
  });
}
export function view(id) {
  return request({
    url: `/quiz/questions/${id}`,
    method: "get"
  });
}
export function store(data) {
  return request({
    url: "/quiz/questions",
    method: "post",
    data
  });
}

export function update(data) {
  return request({
    url: `/quiz/questions/${data.id}`,
    method: "put",
    data
  });
}

export function destroy(id) {
  return request({
    url: `/quiz/questions/${id}`,
    method: "delete"
  });
}
